import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetAllCourses() {
  const URL = endpoints.courses.allCoursesList;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      courses: response || [],
      coursesLoading: isLoading,
      coursesError: error,
      coursesValidating: isValidating,
      coursesEmpty: !isLoading && !response?.courses?.length,
    }),
    [response, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetEnrolledCourses(companyId, userId) {
  const URL = `${endpoints.courses.enrolledCourses}/${companyId}/userId/${userId}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(
    companyId && userId ? URL : null,
    fetcher,
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const response = data?.data;

  const memoizedValue = useMemo(
    () => ({
      enrolledCourses: response || [],
      enrolledCoursesLoading: isLoading,
      enrolledCoursesError: error,
      enrolledCoursesValidating: isValidating,
      enrolledCoursesEmpty: !isLoading && !response?.length,
      enrolledCoursesRefresh: () => mutate(),
    }),
    [response, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export function useGetCourseSections(courseId) {
  const URL = `${endpoints.courses.courseSections}/${courseId}/sections`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      courseSections: response || [],
      courseSectionsLoading: isLoading,
      courseSectionsError: error,
      courseSectionsValidating: isValidating,
      courseSectionsEmpty: !isLoading && !response?.courses?.length,
    }),
    [response, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function enrollCourse(apiData, companyId, userId) {
  const URL = endpoints.courses.allCoursesList;
  const URL2 =`${endpoints.courses.enrolledCourses}/${companyId}/userId/${userId}`;
  try {
    const { data } = await axios.post(endpoints.courses.enroll, apiData);
    if (data.code === 200) {
      await mutate(URL);
      await mutate(URL2)
    }
    return data;
  } catch (error) {
    // console.error('Error creating user:', error);
    throw error;
  }
}

export async function generateCertificate(apiData, companyId, userId) {
  const URL = endpoints.courses.generateCertificate;
  const URL2 =`${endpoints.courses.enrolledCourses}/${companyId}/userId/${userId}`;
  try {
    const { data } = await axios.post(URL, apiData);
    if (data.code === 200) {
      await mutate(URL2)
    }
    return data;
  } catch (error) {
    // console.error('Error creating user:', error);
    throw error;
  }
}


export async function getCertificate(courseId) {
  const URL = `${endpoints.courses.getCertificate}/${courseId}`;
    const { data } = await axios.get(URL);
    // if (data.code === 200) {
    //   await mutate(URL2)
    // }
    return data;
  // try {
  // } catch (error) {
  //   // console.error('Error creating user:', error);
  //   throw error;
  // }
}

export function useGetCompanyCourses() {
  const URL = endpoints.courses.companyCoursesList;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      companyCourses: response || [],
      companyCoursesLoading: isLoading,
      companyCoursesError: error,
      companyCoursesValidating: isValidating,
      companyCoursesEmpty: !isLoading && !response?.companyCourses?.length,
    }),
    [response, error, isLoading, isValidating]
  );

  return memoizedValue;
}
